export default __webpack_public_path__ + "img/aa35a0b6c196333be22706ecc784b31d.mp4";